module.exports = __webpack_public_path__ + "static/claims2-9162e68412ba6cf0a30b209e59d8818e.svg";